import { useReorderFavoriteMutation } from '@crew/apis/favorite/favoriteApis'
import { useCallback } from 'react'

export const useFavoriteProjectList = () => {
  const [reorderFavoriteProjectMutation] = useReorderFavoriteMutation()

  // お気に入りの表示順変更
  const reorderFavoriteProject = useCallback(
    async (fromId: string, toId: string) => {
      await reorderFavoriteProjectMutation({
        projectId: fromId,
        targetPositionProjectId: toId,
      }).unwrap()
    },
    [reorderFavoriteProjectMutation]
  )

  return {
    reorderFavoriteProject,
  }
}
